export default __webpack_public_path__ + "static/media/hasharon2.ef7cf312.jpg";